import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-12" }
const _hoisted_8 = { class: "grid grid-cols-4 gap-6 pt-6 mb-6 border-t mx-7" }
const _hoisted_9 = { class: "mb-6 text-right px-7" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-right p-7" }
const _hoisted_20 = ["innerHTML"]

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import { ref, watch, onMounted, computed } from 'vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BookingService from '@/classes/BookingService';
import BranchService from "@/classes/Branch";
import CompanyService from '@/classes/Company';
import { formatter } from "@/helpers/NumberHelper";
import { format } from 'date-fns';
import { useRouter, useRoute } from 'vue-router';
import { daysOfTheWeek } from '@/helpers/PackageRiderHelper'
import { 
    Employee,
    OtherChargesLinePayload,
    CreateCorporateBookingPayload,
    formattedPackage,
    unformattedPackage,
    formattedRider,
    riderGroup,
    filteredRider,
    medicalPackage,
    medicalRider,
} from '@/interfaces/CorporateBookingInterface'
import * as XLSX from 'xlsx';

const timezoneOffset = 8; // Philippines time zone is UTC+8

export default /*@__PURE__*/_defineComponent({
  __name: 'BookingInformation',
  setup(__props) {

const router    = useRouter();
const route     = useRoute();
const branchId  = ref(Number(route.params.branchId) as unknown as number);
const companyId = ref(Number(route.params.companyId) as unknown as number);

const noAction         = ref(false)
const loader           = ref(false)
const showError        = ref(false)
const errorMsg         = ref()
const errors      = ref([])
const showSuccess      = ref(false)
const showConfirmation = ref(false)
const csvFile          = ref();

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        count: 0,
        href: `branches/${branchId.value}/companies/edit/${companyId.value}`,
        allowed: true
    },
    {
        name: 'Booking',
        count: 0,
        href: `branches/${branchId.value}/companies/booking/${companyId.value}`,
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'First Name' },
    { text: 'Middle Name' },
    { text: 'Last Name' },
    { text: 'Suffix' },
    { text: 'Email' },
    { text: 'Gender' },
    { text: 'Birthday' },
];

const sexes = [
    { id: '1', label: 'Male', value: 'Male' },
    { id: '2', label: 'Female', value: 'Female' },
    // { id: '3', label: 'Prefer not to Say', value: 'Prefer not to Say' },
];

const employeeDefaultValues = {
    cellphone_number : "TBA",
    telephone_number : "TBA",
    civil_status     : "TBA",
    nationality      : "TBA",
    religion         : "TBA",
    job_title        : "TBA",
    birthplace       : "TBA",
    building_number  : "TBA",
    street           : "TBA",
    barangay         : "TBA",
    city             : "TBA",
    province         : "TBA",
    region           : "TBA",
    zip_code         : "TBA",
    philhealth_number: "000000000"
};

const packages               = ref<medicalPackage[]>([]);
const riders                 = ref<medicalRider[]>([]);
const selectedRiders         = ref([]);
const selectedPackage        = ref(null);
const selectedSlot           = ref(null);
const riderGroups            = ref<riderGroup[]>([]);
const unformattedPackages    = ref<unformattedPackage[]>([]);
const employeeCount          = ref(0);
const rider_names            = ref([]);
const timeSlots              = ref([]);

// const unformattedBookingDate = ref(add(new Date, {days: 3}));


const fullyBookedDates = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000 + timezoneOffset * 60 * 60 * 1000); // For 3 days advance booking

const minDate = computed(() => threeDaysLater.toISOString().slice(0, 10));
const from = ref(null);
const to = ref(null);

const selectedDateRef = ref<any>(null)
const selectedDate = ref('')

const employee = ref<Employee>({
    suffix       : null,
    first_name   : null,
    middle_name  : null,
    last_name    : null,
    email_address: null,
    sex          : null,
    birthdate    : null,
})

const payload = ref<CreateCorporateBookingPayload>({
    corporate_id      : companyId.value,
    branch_id         : branchId.value,
    branch_name       : null,
    branch_address    : null,
    corporate_name    : null,
    package_id        : null,
    package_fee       : 0,
    other_charges_line: [],
    other_charges_fee : null,
    booking_date      : null,
    booking_time_start: null,
    booking_time_end  : "11:59:59.000000",
        // Or other known as the corporate patients
    employee_list: [],
    riders: [],
    package_name: null
});

const formatPackages = () => {
    unformattedPackages.value.forEach(unformattedPackage => {
        const formattedPackage: formattedPackage = {
            id   : null,
            label: null,
            value: null,
            disabledDates: null,
        };

        formattedPackage.id    = unformattedPackage.id;
        formattedPackage.value = unformattedPackage.id;
        formattedPackage.label = unformattedPackage.name + ' - ' + formatter.format(unformattedPackage.price);
        formattedPackage.disabledDates = unformattedPackage.disabledDates;
        packages.value.push(formattedPackage);
    });
}

const formatRiders = () => {
    riderGroups.value.forEach(riderGroup => {
        riderGroup.items.forEach(unformattedRider => {
            const formattedRider: formattedRider = {
                id   : null,
                label: null,
                value: null,
                disabledDates: null,
                name: null,
            };
    
            formattedRider.id    = unformattedRider.item_id;
            formattedRider.value = unformattedRider.item_id;
            formattedRider.label = unformattedRider.item_name + ' - ' + formatter.format(unformattedRider.item_price);
            formattedRider.name = unformattedRider.item_name;
            formattedRider.disabledDates = unformattedRider?.disabledDates || [];

            riders.value.push(formattedRider);
        });
    });
}

const isEmailValid = (email: string) => {
    const reg = /[^\s@]+@[^\s@]+\.[^\s@]+/;

    if(email) {
        return reg.test(email) ? true : false;
    }
    
    return false;
}

const validateEmployee = () => {
    if(
        employee.value.first_name    == null ||
        employee.value.last_name     == null ||
        employee.value.email_address == null ||
        employee.value.sex           == null ||
        employee.value.birthdate     == null
    ) {
        showError.value = true;
        errorMsg.value  = "Please fill up all the patient fields.";
    } else if(!isEmailValid(employee.value.email_address)) {
        showError.value = true;
        errorMsg.value  = "Please input a valid email address";
    } else {
        addEmployee();
    }
}

const addEmployee = () => {
    const birthdate = new Date(employee.value.birthdate).toISOString().split('T')[0];
    const employeeDetails = {
        suffix       : employee.value.suffix,
        first_name   : employee.value.first_name,
        middle_name  : employee.value.middle_name,
        last_name    : employee.value.last_name,
        email_address: employee.value.email_address,
        sex          : employee.value.sex,
        birthdate    : birthdate,
        is_from_file : false,
    };
    
    payload.value.employee_list.push(Object.assign(employeeDetails, employeeDefaultValues));

    employeeCount.value++;
    
    resetEmployeeFields();
}

const removeEmployeesFormFile = () => {
    payload.value.employee_list.forEach((employee) => {
        if(employee?.is_from_file){
            const index = payload.value.employee_list.findIndex((item:any) => item == employee)

            removeEmployee(index);
        }
    });

    
}

const removeEmployee = (index: number) => {
    payload.value.employee_list.splice(index, 1);
    employeeCount.value--;
};

const resetEmployeeFields = () => {
    const keys = Object.keys(employee.value);
    keys.forEach(key => employee.value[key] = null);
}

const fetchPackagesAndRiders = () => {
    loader.value = true

    BookingService.getPackagesAndRiders(`company_id=${companyId.value}`)
        .then((result: any) => {
            loader.value = false;
            unformattedPackages.value = result.data.packageResponse;

            const services = result.data.serviceResponse;
            const allergyTests = result.data.allergyTestResponse;
            riderGroups.value = services.concat(allergyTests);

            formatPackages();
            formatRiders();
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchBranch = async () => {
    try {
        loader.value = true;
        const response = await BranchService.editBranch(branchId.value)
        loader.value = false;
        const branchResponse = response.data.branch;

        if(branchResponse) {
            payload.value.branch_name = branchResponse.name;
            payload.value.branch_address = branchResponse.address_line;
        }
    }
    catch(error: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;
    }
}

const redirectToCompanyIndex = () => {
    showSuccess.value = false;
    router.push(`/branches/${branchId.value}/companies/`);
}

const fetchCompany = async() => {
    try {
        loader.value = true;
        const response = await CompanyService.getSelectedCompany(companyId.value)
        loader.value = false;
        const companyResponse = response.data.company;

        if(companyResponse) {
            payload.value.corporate_name = companyResponse.name;
        }
    }
    catch(error: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;
    }
}

const submitBooking = () => {
    loader.value = true;

    payload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
    console.log(payload.value);
    BookingService.submitCorporateBooking(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            // if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            // }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const pushRiderInPayload = (filteredRiders: filteredRider[]) => {
    let riderPrice = 0;
    const rider_item_ids: number[] = [];
    rider_names.value = [];

    filteredRiders.forEach(rider => {
        const formattedRider: OtherChargesLinePayload = {
            ItemID: null,
            Price: null,
        };

        formattedRider.ItemID = rider.item_id;
        formattedRider.Price = rider.item_price;
        riderPrice += rider.item_price;
        payload.value.other_charges_line.push(formattedRider);

        rider_item_ids.push(rider.item_id)
    });

    riderGroups.value.forEach(rider => {
        const item = rider.items.filter(obj => rider_item_ids.includes(obj.item_id));
        if(item.length > 0) {
            item.forEach(a => {
                rider_names.value.push(a.item_name);
            });
        }
    });

    payload.value.other_charges_fee = riderPrice;
    payload.value.riders = rider_names.value;
}

const selectRiders = () => {
    payload.value.other_charges_line = [];

    let filteredRiders: filteredRider[] = [];

    riderGroups.value.forEach(rider => {
        filteredRiders = filteredRiders.concat(rider.items.filter(filteredRider => selectedRiders.value.includes(filteredRider.item_id)));
    });
    
    pushRiderInPayload(filteredRiders);
}

const clearPackagePayload = () => {
    payload.value.package_fee = 0;
    payload.value.package_id = null;
    
    selectedDateRef.value?.datePicker.clearValue()
}

const selectPackage = () => {
    clearPackagePayload();

    const filteredPackage = unformattedPackages.value.filter(unformattedPackage => selectedPackage.value == unformattedPackage.id);
    
    if(filteredPackage){
        payload.value.package_id = filteredPackage[0]?.id;
        payload.value.package_fee = filteredPackage[0]?.price || 0;
        payload.value.package_name = filteredPackage[0]?.name;
    }
}

const getDisabledDates = computed<number[]>(():number[] => {
    let disabledDates:number[] = [];
    
    if(payload.value.package_id){
        const index = packages.value.findIndex( item => item.id == payload.value.package_id );
        
        disabledDates = [...new Set([...disabledDates, ...packages.value[index].disabledDates])]
    }

    if(payload.value.riders){

        payload.value.riders.forEach(rider => {
            const index = riders.value.findIndex(item => item.name == rider);
            disabledDates = [...new Set([...disabledDates, ...riders.value[index].disabledDates])]
        });
    }

    return disabledDates;
});

const isDateValid = (dateString: string) => {
    const timestamp = Date.parse(dateString);
    if (isNaN(timestamp)) {
        return false;
    } else {
        return true;
    }
}

// const pushEmployeesFromCsv = () => {
//     if(csvFile.value) {
//         // FileReader Object
//         const reader = new FileReader();
//         // Read file as string 
//         reader.readAsText(csvFile.value);

//         // Load event
//         reader.onload = function(event) {

//             // Read file data
//             const csvdata = event.target.result;

//             // Split by line break to gets rows Array
//             const rowData = csvdata.split('\n');

//             let invalidPatientCount = 0;

//             // Loop on the row Array (change row=0 if you also want to read 1st row)
//             for (let row = 1; row < rowData.length; row++) {

//                 // Split by comma (,) to get column Array
//                 const rowColData = rowData[row].split(',');
                
//                 if(isDateValid(rowColData[6])) {
//                 employeeCount.value++;

//                 const employeeDetails = {
//                     first_name   : rowColData[0],
//                     middle_name  : rowColData[1],
//                     last_name    : rowColData[2],
//                     suffix       : rowColData[3],
//                     email_address: rowColData[4],
//                     sex          : rowColData[5],
//                     birthdate    : rowColData[6],
//                     is_from_file : true,
//                 };

//                 payload.value.employee_list.push(Object.assign(employeeDetails, employeeDefaultValues));
//                 } else {
//                     invalidPatientCount++;
//                 }
//             }

//             if(invalidPatientCount > 0) {
//                 showError.value = true;
//                 errorMsg.value = `${invalidPatientCount} row/s were not uploaded due to incorrect birth date values`;
//             }
//         };
//     }
// }

const pushEmployeesFromCsv = () => {
  if (!csvFile.value) return;

  const file = csvFile.value as File;
  const ext = file.name.split('.').pop()?.toLowerCase();
  const reader = new FileReader();

  reader.onload = (e: ProgressEvent<FileReader>) => {
    let rows: any[][] = [];

    if (ext === 'csv') {
      const text = e.target?.result as string;
      rows = text.trim().split('\n').map(r => r.split(','));
    }
    else if (ext === 'xlsx' || ext === 'xls') {
      // read with cellDates so date‐cells become JS Date objects
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const wb = XLSX.read(data, { type: 'array', cellDates: true });
      const ws = wb.Sheets[wb.SheetNames[0]];
      // raw:true so we get the actual cell.v values (Date objects, numbers, strings)
      rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true }) as any[][];
    }
    else {
      showError.value = true;
      errorMsg.value = 'Unsupported file format.';
      return;
    }

    let invalidCount = 0;
    // skip header
    rows.slice(1).forEach(cols => {
      // cols[6] is birthdate column
      const cell = cols[6];
      let birthdateStr: string;

    if (cell instanceof Date) {
        // build YYYY-MM-DD from the local Date
        const y = cell.getFullYear();
        const m = String(cell.getMonth() + 1).padStart(2, '0');
        const d = String(cell.getDate()).padStart(2, '0');
        birthdateStr = `${y}-${m}-${d}`;
    } else {
        birthdateStr = String(cell).trim();
    }


      if (!isDateValid(birthdateStr)) {
        invalidCount++;
        return;
      }

      const [first, middle, last, suffix, email, sex] = cols;
      employeeCount.value++;
      payload.value.employee_list.push({
        ...employeeDefaultValues,
        first_name:    first,
        middle_name:   middle,
        last_name:     last,
        suffix:        suffix,
        email_address: email,
        sex:           sex,
        birthdate:     birthdateStr,
        is_from_file:  true,
      } as any);
    });

    if (invalidCount > 0) {
      showError.value = true;
      errorMsg.value = `${invalidCount} row(s) were skipped due to invalid birthdate.`;
    }
  };

  if (ext === 'csv') {
    reader.readAsText(file);
  } else {
    reader.readAsArrayBuffer(file);
  }
};



const fetchDateAndTime = () => {
    if (selectedDate.value) {
        loader.value = true
        
        const data = {
            branch_id: payload.value.branch_id,
            selected_date: selectedDate.value,
            from: from.value,
            to: to.value,
            package: payload.value.package_name,
            riders: rider_names.value,
        }
    
        BookingService.fetchDateAndTime(data)
            .then((result: any) => {
                loader.value = false;
                timeSlots.value = result.data.response
                fullyBookedDates.value = result.data.response.fully_booked_dates;
            })
            .catch((error) => {
                loader.value = false;
                showError.value = true;
                errorMsg.value = error.response?.data?.message;
    
                if(error.response.status == 401) {
                    window.location.replace('/login')
                }
            })
    }
}

const updateMonth = (val:any = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
    fetchDateAndTime();
}

const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

const setStartEndTime = (value:string) => {
    const [start, end] = value.split('-');

    payload.value.booking_time_start = stringToTime(start);
    payload.value.booking_time_end = stringToTime(end);
}

// This function takes a string in the format of "h:mm AM/PM" and returns a string in the format of "hh:mm:ss"
const stringToTime = (str:string): string => {
    // Split the string by space and colon
    const time:string[] = str.split(/[: ]/);
    // Convert hour and minute to numbers
    let hour:number = parseInt(time[0]);
    const minute:number = parseInt(time[1]);
    const period:string = time[2];
    // Check if the period is valid
    if (period !== "AM" && period !== "PM") {
        return "Invalid period";
    }
    // Check if the hour and minute are valid
    if (hour < 1 || hour > 12 || minute < 0 || minute > 59) {
        return "Invalid time";
    }
    // Convert hour to 24-hour format
    if (period === "PM" && hour < 12) {
        hour += 12;
    }
    if (period === "AM" && hour === 12) {
        hour = 0;
    }
    // Pad hour and minute with zeros if needed
    const newHour:string = hour.toString().padStart(2, "0");
    const newMinute:string = minute.toString().padStart(2, "0");
    // Return the time in the format of "hh:mm:ss"
    return `${newHour}:${newMinute}:00`;
}

const resetDateTime = (): void => {
    selectedDate.value = null;
    selectedSlot.value = null;

    selectedDateRef.value?.datePicker.clearValue()

    fetchDateAndTime()
}

watch(
    () => selectedRiders.value,
    (val) => {
        if (val) {
            selectRiders();
        }

        resetDateTime()
    },
    { immediate: true }
);

watch(
    () => selectedPackage.value,
    (val) => {
        if (val) {
            selectPackage();
        } else {
            payload.value.package_id = null;
            payload.value.package_fee = 0;
            payload.value.package_name = '';
        }

        resetDateTime()
    },
    { immediate: true }
);

watch(
    () => csvFile.value,
    () => {
        pushEmployeesFromCsv()
    },
    { immediate: true }
);

watch(
    () => selectedDate.value,
    (val) => {
        if(val){      
            const selectedDate = new Date(val);
    
            updateMonth({
                year: selectedDate.getFullYear(),
                month: selectedDate.getMonth()
            })
        }
    },
    { immediate: true }
);


onMounted(() => {
    fetchPackagesAndRiders();
    fetchCompany();
    fetchBranch();
    // fetchDateAndTime();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Company",
    "show-back": "",
    backUrl: `/branches/${branchId.value}/companies`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          title: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode(" Booking Information ", -1)
          ]))]),
          description: _withCtx(() => [...(_cache[23] || (_cache[23] = [
            _createTextVNode(" Relevant data and other details ", -1)
          ]))]),
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(MultiselectInput, {
                modelValue: selectedPackage.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPackage).value = $event)),
                id: "packages",
                name: "packages",
                label: "Package",
                placeholder: "Package",
                searchable: "",
                options: packages.value
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(MultiselectInput, {
                modelValue: selectedRiders.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRiders).value = $event)),
                id: "selectedRiders",
                name: "selectedRiders",
                label: "Rider/s",
                placeholder: "Rider/s",
                mode: "tags",
                "close-on-select": false,
                searchable: "",
                options: riders.value
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DatePicker, {
                disabled: !selectedPackage.value && selectedRiders.value.length == 0,
                ref_key: "selectedDateRef",
                ref: selectedDateRef,
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDate).value = $event)),
                id: "selectedDate",
                name: "selectedDate",
                label: "Booking Date",
                placeholder: "MM/DD/YYYY",
                "min-date": _unref(currentDate),
                "fully-booked-dates": fullyBookedDates.value,
                "hide-offset-dates": "",
                "highlight-disabled-days": "",
                disabledWeekDays: getDisabledDates.value
              }, null, 8, ["disabled", "modelValue", "min-date", "fully-booked-dates", "disabledWeekDays"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(MultiselectInput, {
                disabled: !selectedDate.value,
                modelValue: selectedSlot.value,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((selectedSlot).value = $event)),
                  setStartEndTime
                ],
                id: "selectedSlot",
                name: "selectedSlot",
                label: "Time Slots",
                placeholder: "Time Slots",
                searchable: "",
                options: timeSlots.value
              }, null, 8, ["disabled", "modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TextInput, {
                modelValue: employeeCount.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((employeeCount).value = $event)),
                id: "employeeCount",
                name: "employeeCount",
                label: "Number of Employees",
                placeholder: "Number of Employees",
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DropzoneInput, {
                file: csvFile.value,
                "onUpdate:file": _cache[5] || (_cache[5] = ($event: any) => ((csvFile).value = $event)),
                label: "Participating Corporate Employees",
                description: "CSV, EXCEL file",
                accept: ".csv,.xlsx,.xls",
                "onDelete:file": _cache[6] || (_cache[6] = ($event: any) => (removeEmployeesFormFile()))
              }, null, 8, ["file"]),
              _cache[24] || (_cache[24] = _createElementVNode("a", {
                href: "/assets/files/shinagawa-patients.csv",
                download: "",
                class: "inline-block mt-3 text-blue-500"
              }, " Download Corporate Patient List Manifest ", -1))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createVNode(TextInput, {
            modelValue: employee.value.first_name,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((employee.value.first_name) = $event)),
            id: "first_name",
            name: "first_name",
            label: "First Name",
            placeholder: "First Name"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(TextInput, {
            modelValue: employee.value.middle_name,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((employee.value.middle_name) = $event)),
            id: "middle_name",
            name: "middle_name",
            label: "Middle Name",
            placeholder: "Middle Name"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(TextInput, {
            modelValue: employee.value.last_name,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((employee.value.last_name) = $event)),
            id: "last_name",
            name: "last_name",
            label: "Last Name",
            placeholder: "Last Name"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(TextInput, {
            modelValue: employee.value.suffix,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((employee.value.suffix) = $event)),
            id: "suffix",
            name: "suffix",
            label: "Suffix",
            placeholder: "Suffix"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(TextInput, {
            modelValue: employee.value.email_address,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((employee.value.email_address) = $event)),
            id: "email_address",
            name: "email_address",
            label: "Email",
            placeholder: "Email"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(MultiselectInput, {
            modelValue: employee.value.sex,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((employee.value.sex) = $event)),
            id: "sex",
            name: "sex",
            label: "Sex",
            placeholder: "Sex",
            options: sexes
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(DatePicker, {
            modelValue: employee.value.birthdate,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((employee.value.birthdate) = $event)),
            id: "birthdate",
            name: "birthdate",
            label: "Birthday",
            placeholder: "MM/DD/YYYY"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.$hasPermission('add-employees-to-a-company') || _ctx.$hasPermission('update-corporate-patient'))
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (validateEmployee()))
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode(" Add Employee ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(DataTable, {
          headers: headers,
          "no-action": noAction.value,
          count: employeeCount.value
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payload.value.employee_list, (employee, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: employee.id
              }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(employee.first_name), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(employee.middle_name), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(employee.last_name), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(employee.suffix), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(TextInput, {
                    modelValue: payload.value.employee_list[index].email_address,
                    "onUpdate:modelValue": ($event: any) => ((payload.value.employee_list[index].email_address) = $event),
                    placeholder: "Email"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("td", _hoisted_16, _toDisplayString(employee.sex), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(format)(new Date(employee.birthdate), 'LLL dd, yyyy')), 1),
                (!noAction.value && (_ctx.$hasPermission('add-employees-to-a-company') || _ctx.$hasPermission('update-corporate-patient')))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      onClick: ($event: any) => (removeEmployee(index)),
                      class: "text-center"
                    }, [
                      _createVNode(ActionButton, { "close-btn": "" })
                    ], 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["no-action", "count"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.$hasPermission('add-employees-to-a-company') || _ctx.$hasPermission('update-corporate-patient'))
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              onClick: _cache[15] || (_cache[15] = ($event: any) => (showConfirmation.value = true))
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode(" Submit ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[16] || (_cache[16] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("p", { innerHTML: errorMsg.value }, null, 8, _hoisted_20)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[18] || (_cache[18] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[19] || (_cache[19] = ($event: any) => (redirectToCompanyIndex())),
        "action-text": "Confirm",
        title: "Corporate Booking Submitted!",
        content: "Corporate booking has been submitted successfully"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[20] || (_cache[20] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[21] || (_cache[21] = ($event: any) => {showConfirmation.value = false; submitBooking()}),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Submit Corporate Booking?",
        content: "Are you sure you wish to submit this corporate booking?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})